// @flow
import {
  GeneralSwatchAction,
  GeneralSwatchState,
  GET_GENERAL_SWATCH_REQUEST,
  GET_GENERAL_SWATCH_SUCCESS,
  GET_GENERAL_SWATCH_FAILURE,
  GET_GENERAL_SWATCH_SETTINGS_REQUEST,
  GET_GENERAL_SWATCH_SETTINGS_SUCCESS,
  GET_GENERAL_SWATCH_SETTINGS_FAILURE,
  UPDATE_GENERAL_SWATCH_SETTINGS_REQUEST,
  UPDATE_GENERAL_SWATCH_SETTINGS_SUCCESS,
  UPDATE_GENERAL_SWATCH_SETTINGS_FAILURE,
} from 'stores/flow-type/general-swatch-type';

const initialState: GeneralSwatchState = {
  loading: false,
  success: false,
  error: undefined,
  loadingSwatchSettings: false,
  successSwatchSettings: false,
  errorSwatchSettings: undefined,
  generalSwatch: [],
  generalSwatchSettings: null,
  updateLoading: false,
  total: 0,
};

const generalSwatchReducers = (
  state: GeneralSwatchState = initialState,
  action: GeneralSwatchAction
) => {
  const { type } = action;

  switch (type) {
    case GET_GENERAL_SWATCH_REQUEST:
      return {
        ...state,
        loading: true,
        success: false,
        error: null,
      };
    case GET_GENERAL_SWATCH_SUCCESS: {
      const { data } = action.payload;

      return {
        ...state,
        loading: false,
        success: true,
        error: undefined,
        generalSwatch: data,
      };
    }
    case GET_GENERAL_SWATCH_FAILURE:
      return {
        ...state,
        loading: false,
        error: String(action.payload),
        success: false,
      };

    case GET_GENERAL_SWATCH_SETTINGS_REQUEST:
      return {
        ...state,
        loadingSwatchSettings: true,
        successSwatchSettings: false,
        errorSwatchSettings: null,
        generalSwatchSettings: null,
      };
    case GET_GENERAL_SWATCH_SETTINGS_SUCCESS: {
      const { data: result } = action.payload;

      return {
        ...state,
        loadingSwatchSettings: false,
        successSwatchSettings: true,
        errorSwatchSettings: undefined,
        generalSwatchSettings: result.data,
        total: result.total,
      };
    }
    case GET_GENERAL_SWATCH_SETTINGS_FAILURE:
      return {
        ...state,
        loadingSwatchSettings: false,
        errorSwatchSettings: String(action.payload),
        successSwatchSettings: false,
      };
    case UPDATE_GENERAL_SWATCH_SETTINGS_REQUEST:
      return {
        ...state,
        updateLoading: true
      };
    case UPDATE_GENERAL_SWATCH_SETTINGS_SUCCESS: {
      const { data: result } = action.payload;

      return {
        ...state,
        updateLoading: false,
        error: undefined,
        generalSwatchSettings: result.data
      };
    } case UPDATE_GENERAL_SWATCH_SETTINGS_FAILURE:
      return {
        ...state,
        updateLoading: false,
        success: false,
        error: action.payload
      };
    default:
      return state;
  }
};

export default generalSwatchReducers;
